import type {Customization, CustomizationOption} from './types'

// Format text to title case (First Letter Capitalized)
export function formatOptionName(text: string): string {
  if (!text) return text
  
  return text
    .toLowerCase()
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

// Extract customization text from food item
export function getCustomizationText(customizations: Customization[]): string {
  if (!customizations.length) return ''
  
  const selectedOptions: string[] = []
  
  const extractOptions = (customizations: Customization[]): void => {
    customizations.forEach((customization: Customization) => {
      customization.selectedOptions?.forEach((option: CustomizationOption) => {
        if (option.quantity > 0) {
          selectedOptions.push(formatOptionName(option.name))
          if (option.customizations) {
            extractOptions(option.customizations)
          }
        }
      })
    })
  }
  
  try {
    extractOptions(customizations)
    return selectedOptions.join(', ')
  } catch {
    return 'Customized'
  }
} 